import { Link, useParams } from 'react-router-dom'
import { FaFacebookF, FaWhatsapp } from 'react-icons/fa'
import { FaXTwitter } from 'react-icons/fa6'
import { FaLinkedinIn } from 'react-icons/fa'
import { FaYoutube } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const { t } = useTranslation()
  const { lng } = useParams()

  return (
    <>
      <div className="mt-16 bg-light py-16">
        <div className="app-container">
          <div className="px-8">
            <p
              data-aos="fade-down"
              className="font-bold text-secondary-600"
            >
              {' '}
              {t('WEBSITE_MAP')}
            </p>
            <div
              data-aos="fade-down"
              className="grid grid-cols-12 gap-4 gap-y-8 p-8"
            >
              <div className="col-span-12 flex flex-col sm:col-span-6 md:col-span-3">
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/home`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {t('HOME')}
                  </Link>
                </div>
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/about`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {t('ABOUT')}
                  </Link>
                </div>
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/minerals/alalmnyom-aluminium/prices?CHART=AREA&INTERVAL=MONTH`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {t('MINERALS_PRICES')}{' '}
                  </Link>
                </div>
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/opportunities`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {t('OPPORTUNITIES')}
                  </Link>
                </div>
                <div className="p-1.5">
                  <Link
                    target="_blank"
                    to={`/region/map`}
                    // to={`/region/map?lang=${lng}`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {t('REGION_MAP')}
                  </Link>
                </div>
              </div>
              <div className="col-span-12 flex flex-col sm:col-span-6 md:col-span-3">
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/future-minerals?category=1`}
                    className="font-bold hover:text-secondary-600"
                  >
                    {' '}
                    {t('CLEAN_ENERGY_MINERALS')}{' '}
                  </Link>
                </div>
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/future-minerals/region?category=1`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {' '}
                    {t('FUTURE_MINERALS_REGION')}{' '}
                  </Link>
                </div>
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/future-minerals/clean-energy/arab-production`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {' '}
                    {t('ARAB_PRODUCTION')}
                  </Link>
                </div>
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/future-minerals/value-chains?category=1`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {t('VALUE_CHAIN')}{' '}
                  </Link>
                </div>
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/future-minerals/clean-energy/global-demand`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {t('GLOBAL_DEMAND')}{' '}
                  </Link>
                </div>
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/future-minerals/clean-energy/technologies`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {t('CLEAN_ENERGY_TECHNOLOGIES')}{' '}
                  </Link>
                </div>
              </div>
              <div className="col-span-12 flex flex-col sm:col-span-6 md:col-span-3">
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/future-minerals?category=2`}
                    className="font-bold hover:text-secondary-600"
                  >
                    {t('INDUSTRIAL_MINERALS')}{' '}
                  </Link>
                </div>
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/future-minerals/region?category=2`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {' '}
                    {t('FUTURE_MINERALS_REGION')}{' '}
                  </Link>
                </div>
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/future-minerals/industrial/arab-production`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {' '}
                    {t('ARAB_PRODUCTION')}
                  </Link>
                </div>
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/future-minerals/value-chains?category=2`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {t('VALUE_CHAIN')}{' '}
                  </Link>
                </div>
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/future-minerals/industrial/industries`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {t('MAIN_INDUSTRIES')}{' '}
                  </Link>
                </div>
              </div>
              <div className="col-span-12 flex flex-col sm:col-span-6 md:col-span-3">
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/future-minerals?category=2`}
                    className="font-bold hover:text-secondary-600"
                  >
                    {t('FOOD_SECURITY_MINERALS')}{' '}
                  </Link>
                </div>
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/future-minerals/region?category=4`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {' '}
                    {t('FUTURE_MINERALS_REGION')}{' '}
                  </Link>
                </div>
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/future-minerals/security/arab-production`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {' '}
                    {t('ARAB_PRODUCTION')}
                  </Link>
                </div>
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/future-minerals/value-chains?category=4`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {t('VALUE_CHAIN')}{' '}
                  </Link>
                </div>
                <div className="p-1.5">
                  <Link
                    to={`/${lng}/future-minerals/security/securities`}
                    className="hover:text-secondary-600 hover:underline"
                  >
                    {t('AGRICULTURAL_APPLICATIONS')}{' '}
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="px-8">
            <p
              data-aos="fade-down"
              className="font-bold text-secondary-600"
            >
              {t('CONTACT_US')}{' '}
            </p>
            <div
              data-aos="fade-down"
              className="grid grid-cols-12 gap-y-8 p-8"
            >
              <div className="col-span-12 sm:col-span-6 md:col-span-4">
                <div className="item p-2">
                  <p className="t font-bold">{t('ADDRESS')}</p>
                  <p className="">{t('ADDSRESS')}</p>
                </div>
                <div className="item p-2">
                  <p className="t font-bold">{t('PHONE')}</p>
                  <p className="">00212537274500</p>
                </div>
                <div className="item p-2">
                  <p className="t font-bold">{t('FAX')}</p>
                  <p className="">00212537772188</p>
                </div>
                <div className="item p-2">
                  <p className="t font-bold">{t('EMAIL')}</p>
                  <p className="">aidsmo@aidsmo.org</p>
                </div>
              </div>
              <div className="col-span-12 sm:col-span-6 md:col-span-8">
                <div className="mx-auto max-w-fit">
                  <div className="m-auto flex max-w-fit gap-4">
                    <Link
                      to={`https://aidsmo.org/`}
                      target="_black"
                      className="h-[200px] w-[200px]"
                    >
                      <img
                        src="/assets/logos/aidsmo_logo.webp"
                        alt=""
                        className="w-full object-cover"
                      />
                    </Link>
                    <Link
                      to={`/${lng}/home`}
                      className="h-[200px] w-[200px]"
                    >
                      <img
                        src="/assets/logos/app_logo.svg"
                        alt=""
                        className="w-full object-cover"
                      />
                    </Link>
                  </div>
                  {/* social links */}
                  <div className="flex flex-row-reverse justify-center gap-4 md:my-8 md:justify-start">
                    <Link
                      target="_blank"
                      className="bg-primary-600 p-3 text-white hover:bg-secondary-600"
                    >
                      <FaXTwitter />
                    </Link>
                    <Link
                      target="_blank"
                      className="bg-primary-600 p-3 text-white hover:bg-secondary-600"
                    >
                      <FaFacebookF />
                    </Link>
                    <Link
                      target="_blank"
                      className="bg-primary-600 p-3 text-white hover:bg-secondary-600"
                    >
                      <FaYoutube />
                    </Link>
                    <Link
                      target="_blank"
                      className="bg-primary-600 p-3 text-white hover:bg-secondary-600"
                    >
                      <FaLinkedinIn />
                    </Link>
                    <Link
                      target="_blank"
                      className="bg-primary-600 p-3 text-white hover:bg-secondary-600"
                    >
                      <FaWhatsapp />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-secondary-600">
        <p className="p-4 text-center text-white">{t('COPYRIGHT')}</p>
      </div>
    </>
  )
}

export default Footer
